import { render, staticRenderFns } from "./ExternalDamageModal.vue?vue&type=template&id=28c4d924&scoped=true"
import script from "./ExternalDamageModal.vue?vue&type=script&lang=ts"
export * from "./ExternalDamageModal.vue?vue&type=script&lang=ts"
import style0 from "./ExternalDamageModal.vue?vue&type=style&index=0&id=28c4d924&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c4d924",
  null
  
)

export default component.exports